/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Status_DuplicateInputs */



/**
* | output |
* | --- |
* | "Duplicate in file" |
*
* @param {Team_Manager_Import_Status_DuplicateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_status_duplicate = /** @type {((inputs?: Team_Manager_Import_Status_DuplicateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Status_DuplicateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Doublon dans le fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Doppelt in der Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Duplicato nel file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повтор в файле")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duplicado en el archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件中重复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル内で重複")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल में डुप्लिकेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duplicado no ficheiro")
	return /** @type {LocalizedString} */ ("Duplicate in file")
});